import styled from 'styled-components'

export const NoDataBox = styled.div`
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 450;
  padding: 50px 0px;

  @media (max-width: 1540px) {
    font-size: 0.95em;
  }
`

export const ContainerTable = styled.div`
  display: flex;
  width: 100%;
  height: 90%;
  flex: 8;
  gap: 16px;
  flex-direction: column;
`
